import React from 'react';
import { t, props } from 'tcomb-react';
import Locale from '../domain/Locale';

@props({
  locale: Locale,
  price: t.Str,
  discount: t.Str,
  saving: t.Str,
  delta: t.maybe(t.Str)
})
export default class Deal extends React.Component {

  render() {
    return (
      <table className="std-table">
        <tbody>
          <tr>
            <td className="large-30">{ this.props.price }</td>
            <td className="large-30"> - { this.props.saving }</td>
            <td className="large-30">{ this.props.delta }</td>
          </tr>
        </tbody>
      </table>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Deal.js
 **/